import(/* webpackMode: "eager" */ "/home/runner/work/dashboard-next/dashboard-next/src/app/loading.tsx");
